import React from 'react'
import styled from 'styled-components'

const thComponent = ({ children, ...otherProps }) => (
  <th {...otherProps}>{children}</th>
)

export const Th = styled(thComponent)`
  color: ${props => props.theme.colors.regentGray3};
  font-family: ${props => props.theme.fonts.robotoRegular};
  font-size: ${props => props.theme.fontSizes.table.th};
  letter-spacing: 1.5px;
  text-transform: uppercase;
  background: ${props => props.theme.colors.white};
  padding: 40px 10px 25px 10px;

  .flex-centered {
    display: flex;
    justify-content: center;
  }

  &.centered {
    text-align: center;
  }

  &.no-wrap {
    white-space: nowrap;
  }

  &.align-right {
    text-align: right;
  }

  &.align-left {
    text-align: left;
  }

  &.sortable {
    cursor: pointer;
  }
`
